export const PROFILE_SETTINGS_URL = '/settings/profile'
export const NOTIFICATIONS_URL = '/member/notifications'
